module.exports = __webpack_public_path__ + "img/car_05.f06ffe2b.jpg";